<p-toast></p-toast>

<div
	*ngIf="loading"
	class="flex align-items-center justify-content-center m-0 p-0"
>
	<p-progressSpinner></p-progressSpinner>
</div>

<div class="card-container" *ngIf="!loading">
	<div class="card text-center" *ngIf="getUser().role_id === 1">
		<h2>{{ data?.users }}</h2>
		<p>Usuarios</p>
	</div>

	<div class="card text-center" *ngIf="getUser().role_id != 4">
		<h2>{{ data?.services }}</h2>
		<p>Servicios</p>
	</div>

	<div class="card text-center" *ngIf="getUser().role_id != 4">
		<h2>{{ data?.extras }}</h2>
		<p>Extras</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.housings }}</h2>
		<p>Viviendas</p>
	</div>

	<div class="card text-center">
		<h2>{{ data?.reservations }}</h2>
		<p>Reservas</p>
	</div>
	
	<div class="card text-center">
		<h2>{{ data?.reservations_ko }}</h2>
		<p>Reservas en espera</p>
	</div>
	
	<div class="card text-center">
		<h2>{{ data?.reservations_ok }}</h2>
		<p>Reservas completadas</p>
	</div>
</div>

<div *ngIf="!loading" class="text-center mt-4 infoVersion">
	{{versionApp}}
</div>